module.exports = __webpack_public_path__ + "static/media/cutway_collar.9a733341.svg";